<div class="return-settings-general">
    <div class="card panel-flat-color primary-panel flex-panel">
        <div class="panel-flat-header ws-flex-container-horizontal">
            <h3 class="ws-truncate ws-flex-auto">
                General Return Settings
            </h3>
            <div class="ws-flex-none header-button-container">
                @if (!editMode && canEdit) {
                    <button
                        title="Edit"
                        type="button"
                        class="ace-btn btn-text has-icon btn-primary"
                        [disabled]="!canEnterEditMode"
                        (click)="edit()">
                        <i class="fa fa-pencil fa-align"></i>
                    </button>
                }
                @if (editMode) {
                    <button title="Save"
                            type="button"
                            class="ace-btn btn-text has-icon btn-primary"
                            [disabled]="!hasChanges"
                            (click)="save()">
                        <i class="fa fa-save fa-align"></i>
                    </button>
                }
                @if (editMode) {
                    <button title="Cancel"
                            type="button"
                            class="ace-btn btn-text has-icon btn-primary"
                            (click)="cancel()">
                        <i class="fa fa-times fa-align"></i>
                    </button>
                }
            </div>
        </div>
        <div class="panel-flat-body">
            @if (showReportNBVInsteadOfFactoredCost) {
                <div class="mb-3 row"
                     title="When enabled and forms support it, Assets NBV will be used to calculate the Reported value.">
                    <div class="col-md-2 row-header">Report Net Book Value instead of factored cost:</div>
                    <div class="col-md-3">
                        <ws-switch name="reportNBVInsteadOfFactoredCost"
                                   [formControl]="reportNBVInsteadOfFactoredCostControl"
                                   (selectedOptionChanged)="reportNBVInsteadOfFactoredCostChanged($event)">
                        </ws-switch>
                    </div>
                </div>
            }
            @if (showReturnCostReportingDisplay) {
                <div class="mb-3 row">
                    <div class="col-md-2 row-header">Form Cost Display:</div>
                    <div class="col-md-3">
                        <select name="returnCostReportingDisplay"
                                class="form-select form-select-sm"
                                [formControl]="returnCostReportingDisplayControl"
                                (ngModelChange)="returnCostReportingDisplayChanged($event)">
                            <option value="1">Cost</option>
                            <option value="2">Est. FMV</option>
                            <option value="3">Both</option>
                        </select>
                    </div>
                </div>
            }
        </div>
    </div>
</div>
